import React, { useState, useEffect } from "react";
import { DeleteForever } from "@mui/icons-material";
import { Button } from "react-bootstrap";
import CustomBreadcrumbs from "../../Tools/Breadcumbs";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { get_schemes, getActivity, getSubActivity, fetchSchemesOnly, add_subhead_budget } from "../../../helper/Api";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Box,
  IconButton,
  Typography,
} from "@mui/material";

const AddSubHeadForm = () => {
  const navigate = useNavigate();
  const [codeError, setCodeError] = useState(false);
  const [schemes, setSchemes] = useState([]);
  const [activity, setActivities] = useState([]);
  const [subActivity, setSubActivities] = useState([]);
  const [is_activity_active, setIsActivityActive] = useState(false);
  const linksArray = [
    {
      href: "/schemes",
      label: "Schemes",
    },
  ];
  const [formData, setFormData] = useState({
    scheme_id: "",
    name: "",
    code: "",
  });

  const fetchSchemes = async () => {
    try {
      const response = await fetchSchemesOnly();
      if (response.status === 200) {
        setSchemes(response.data.schemes);
      } else {
        console.error("Failed to fetch schemes");
      }
    } catch (error) {
      console.error("Error fetching schemes:", error);
    }
  };

  const fetchActivities = async () => {
    try {
      const response = await getActivity();
      if (response.status === 200) {
        setActivities(response.data.result);
      } else {
        console.error("Failed to fetch activities");
      }
    } catch (error) {
      console.error("Error fetching activities:", error);
    }
  };

  const fetchSubActivities = async () => {
    try {
      const response = await getSubActivity();
      if (response.status === 200) {
        setSubActivities(response.data.result);
      } else {
        console.error("Failed to fetch sub-activities");
      }
    } catch (error) {
      console.error("Error fetching sub-activities:", error);
    }
  };

  useEffect(() => {
    fetchSchemes();
    fetchActivities();
    fetchSubActivities();
  }, []);

  const handleSchemFormData = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if(name === "scheme_id") {
        const selectedScheme = schemes.find((scheme) => Number(scheme.id) === Number(value));
        if (selectedScheme) {
            setIsActivityActive(Number(selectedScheme.is_activity_active) === 1 ? true : false);
        } else {
            setIsActivityActive(false);
        }
    }
    if (name === "code") {
      if (value && value.length !== 2) {
        setCodeError(true);
        return;
      }
      setCodeError(false);
    }
    setFormData({ ...formData, [name]: value });
  };

  const handleActivityChange = (activityIndex, e, activityId) => {
    const { name, value } = e.target;
    // const SubHeads = [...formData.sub_heads];
    if (activityId) {
      const activityValid = formData.activity.find(
        (item) =>
          item.subactivity_id === value && item.activity_id === activityId
      );
      if (activityValid) {
        return alert("Sub-activity already selected");
      }
    }
    setFormData((prevFormData) => {
      const updatedActivities = prevFormData.activity.map((activity, aIdx) => {
        if (aIdx === activityIndex) {
          const updatedActivity = {
            ...activity,
            [name]: value,
          };
          if (name === "activity_id") {
            updatedActivity.subactivity_id = "";
          }
          return updatedActivity;
        }
        return activity;
      });
      return {
        ...prevFormData,
        activity: updatedActivities,
      };
    });
  };

  const findSubActivitiesById = (id) => {
    let listData = subActivity;
    return listData.filter((subActivity) => subActivity.activity_id === id);
  };

  const addNewActivity = () => {
    const newActivity = { activity_id: "", subactivity_id: "" };
    setFormData((prevFormData) => {
      const updatedActivities = [...prevFormData.activity, newActivity];
      return {
        ...prevFormData,
        activity: updatedActivities,
      };
    });
  };

  const deleteNewActivity = (activityIndex) => {
    if (formData.activity.length > 1) {
      setFormData((prevFormData) => {
        const updatedActivities = [...prevFormData.activity];
        updatedActivities.splice(activityIndex, 1);
        return {
          ...prevFormData,
          activity: updatedActivities,
        };
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await add_subhead_budget(formData);
      if(res.data.status) {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        navigate("/schemes");
      }
    }catch(err) {
      toast.error('Something went wrong', {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }

  return (
    <>
      <div className="row" style={{ padding: "10px 16px" }}>
        <div className="col-md-6">
          <h4>Add Subhead</h4>
          <CustomBreadcrumbs linksArray={linksArray} title="Add Subhead" />
        </div>
        <div className="col-md-6">
          <div
            className="d-flex gap-2"
            style={{ width: "auto", float: "right" }}
          >
            <button
              type="submit"
              className="submit_button"
              onClick={handleSubmit}
            >
              <span className="fs-14px">Save</span>
            </button>
          </div>
        </div>
      </div>
      <div className="p-3">
        <Card variant="outlined">
          <CardContent>
            <div className="row">
              <div className="col-sm-4 p-2">
                <FormControl fullWidth>
                  <InputLabel id="scheme-namelabel">Scheme</InputLabel>
                  <Select
                    labelId="scheme-namelabel"
                    id="scheme-name-select"
                    value={formData.scheme_id || ""}
                    label="Scheme"
                    name="scheme_id"
                    onChange={handleSchemFormData}
                  >
                    {schemes.map((scheme) => (
                      <MenuItem value={scheme.id} key={scheme.id}>
                        {scheme.code} | {scheme.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>

              <div className="col-sm-4 p-2">
                <FormControl fullWidth>
                  <TextField
                    id="name"
                    label="Subhead Name"
                    variant="outlined"
                    type="text"
                    name="name"
                    onChange={handleSchemFormData}
                    required
                  />
                </FormControl>
              </div>

              <div className="col-sm-4 p-2">
                <FormControl fullWidth>
                  <TextField
                    id="code"
                    label="Subhead Code"
                    variant="outlined"
                    type="number"
                    name="code"
                    onChange={handleSchemFormData}
                    required
                    error={codeError}
                    helperText={
                      codeError ? "Subhead Code must be 2 digit number" : ""
                    }
                  />
                </FormControl>
              </div>

              {/* {is_activity_active && (
                <div className="col-md-12 overflow-auto m-0">
                  <table className="table table-bordered">
                    <thead className="text-center-custom">
                      <tr>
                        <th scope="col" width="150px">
                          Activity
                        </th>
                        <th scope="col" width="150px">
                          Subactivity
                        </th>
                        <th scope="col" width="150px">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-center-custom">
                      {formData?.activity &&
                        formData?.activity.map((activityData, index) => (
                          <tr key={index}>
                            <td>
                              <select
                                className="form-control"
                                name="activity_id"
                                value={activityData.activity_id}
                                onChange={(e) => handleActivityChange(index, e)}
                              >
                                <option value="">---Select---</option>
                                {activity.map((e) => (
                                  <option key={e.id} value={e.id}>
                                    {e.activity}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <td>
                              <select
                                className="form-control"
                                name="subactivity_id"
                                value={activityData.subactivity_id}
                                onChange={(e) =>
                                  handleActivityChange(
                                    index,
                                    e,
                                    activityData.activity_id
                                  )
                                }
                              >
                                <option value="">---Select---</option>
                                {findSubActivitiesById(
                                  activityData.activity_id
                                ).map((e) => (
                                  <option key={e.id} value={e.id}>
                                    {e.subactivity}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <td>
                              {index === formData.activity.length - 1 && (
                                <button
                                  className="btn btn-primary mx-2"
                                  onClick={(e) => addNewActivity()}
                                >
                                  <AddIcon />
                                </button>
                              )}
                              {index !== formData.activity.length - 1 && (
                                <button
                                  type="button"
                                  className="btn btn-danger mx-2"
                                  onClick={(e) => deleteNewActivity(index)}
                                >
                                  <DeleteForever />
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              )} */}
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default AddSubHeadForm;
